import React, { useContext, useEffect, useMemo, useState, useRef } from 'react'
import { Grid, makeStyles, Typography } from '@material-ui/core'
import { isSafari } from 'react-device-detect'
import HelpRounded from '@material-ui/icons/HelpRounded'
import * as d3 from 'd3'
import { isEmpty } from 'lodash'
import charts from '../data/creditAnalysisChart'
import PageSection from '../components/PageSection'
import ChartDialog from '../components/ChartDialog'
import expandIcon from '../assets/images/expandNew.svg'
import closePopupIcon from '../assets/images/colosePopup.svg'
import ChartD3ToggleGroup from '../components/ChartD3ToggleGroup'
import { Context as PortfolioContext } from '../contexts/portfolio'
import { getCookie, setCookieHelper } from '../ultils/cookie'
import FilterBoxCommon from '../components/FilterBoxCommon'
import {
  FUNDAMENTAL_TOGGLE_COLOR,
  TOGGLE_INDEX,
} from '../ultils/chart-d3-utils'
import PoDChart from '../components/PoDChart'
import DriverChart from '../components/DriverChart'
import PoDTooltipModal from '../components/PoDTooltipModal'
import DriverTooltipModal from '../components/DriverTooltipModal'
import ImpliedRatingChart from '../components/ImpliedRatingChart'
import ControlPointIcon from '@material-ui/icons/ControlPoint'
import CloseIcon from '@material-ui/icons/Close'
import { ClearIcon, SearchIcon } from '../components/Icons'
import Spinner from '../assets/images/spinner.gif'
import OutsideClickHandler from 'react-outside-click-handler'
import { userService } from '../services/users.services'
import { EXPIRED_SECOND } from '../constants/Cookie'
import { mergePodCompareToPod } from '../ultils/dataUtil'
import { getPodToggleStateAfterCustomPeerAdded } from '../ultils/fundamentalsCreditAnalysis'

let _ = require('lodash')

export const filterData = [
  { id: 0, value: '2 years' },
  { id: 1, value: '5 years' },
  { id: 2, value: '10 years' },
]

const useStyles = makeStyles({
  chartDiv: {
    position: 'relative',
    padding: '8px 0px 0px 0px !important',
  },
  chartDivFirst: {
    marginRight: 20,
  },
  subheadingTitle: {
    marginRight: 7,
  },
  subheading: {
    width: '100%',
    marginLeft: 0,
    fontWeight: 600,
    fontSize: 16,
    lineHeight: '22px',
    color: '#474747',
    display: 'flex',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    alignItems: 'center',
    '& img': {
      width: 19,
      height: 25,
      marginLeft: 5,
      cursor: 'pointer',
    },
    // '& svg': {
    //   width: 14,
    //   height: 14,
    //   cursor: 'pointer',
    //   color: '#757575',
    //   marginLeft: 5,
    // },
  },
  subheadingInModal: {
    fontWeight: 600,
    fontSize: 24,
    lineHeight: '28px',
    color: '#181818',
    display: 'flex',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    alignItems: 'center',
    '& img': {
      width: 19,
      height: 25,
      marginLeft: 5,
      cursor: 'pointer',
    },
  },
  subTitle: {
    fontSize: 'calc(50% + 0.2vw)',
    fontWeight: 600,
    marginLeft: 5,
  },
  help: {
    display: 'flex',
    alignItems: 'center',
    '& > div': {
      fontSize: 14,
      display: 'flex',
      alignItems: 'center',
      whiteSpace: 'nowrap',
    },
    '& svg': {
      // width: 20,
      // height: 20,
      // marginLeft: 5,
      // cursor: 'pointer',
      // color: '#474747',
    },
  },
  smallLineChart: {
    height: '280px',
    maxWidth: '100%',
    position: 'relative',
    marginLeft: -10,
  },
  impliedRatingChartDiv: {
    height: '190px',
    maxWidth: '100%',
    position: 'relative',
    marginLeft: -10,
  },
  fullLineChart: {
    height: 'calc(100% - 100px)',
    maxWidth: '100%',
  },
  fullStackAreaChart: {
    height: 'calc(100% - 100px)',
    maxWidth: '100%',
  },
  marketContextContainer: {
    // margin: '0px 0px 0px -12px',
    margin: 'unset !important',
    width: '100%',
    background: '#fff',
    '& .MuiGrid-item': {
      // padding: '16px 12px 0px 12px',
    },
  },
  chartHeader: {
    color: '#474747',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: 10,
  },
  expandIcon: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    color: '#1B3963',
    background: '#EDF2F7',
    borderRadius: 4,
    width: 32,
    height: 32,
    '& img': {
      width: 32,
      height: 32,
    },
    '& svg': {
      width: 32,
    },
  },
  closeBtn: {
    width: 36,
    height: 36,
    borderRadius: 999,
    background: '#F2F2F2',
    marginLeft: 20,
  },
  menuDateGroup: {
    '& .MuiPaper-root': {
      '& .MuiList-root': {
        padding: 0,
        borderRadius: 'unset',
        '& .MuiButtonBase-root': {
          minHeight: 'unset',
          fontSize: 14,
          lineHeight: '18px',
          fontWeight: 'normal',
          color: '#474747',
        },
      },
    },
  },
  formControlDate: {
    marginLeft: 20,
    width: '100%',
    minWidth: 190,
    '& .MuiFormLabel-root': {
      fontSize: 12,
      lineHeight: '18px',
      transform: 'none',
      marginBottom: 8,
      position: 'unset',
    },
    '& .MuiInputBase-root': {
      height: 40,
      marginTop: 'unset',
      backgroundColor: '#F4F5F7',
      borderRadius: '3px',
      display: 'unset',
      '& .MuiSelect-root': {
        height: '100%',
        fontSize: 14,
        lineHeight: '18px',
        fontWeight: 400,
        color: '#474747',
        padding: '0px',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        backgroundColor: 'transparent !important',
        paddingLeft: 10,
      },
      '& svg': {
        position: 'absolute',
        right: 10,
        top: 6,
        width: 9,
        transform: 'rotate(180deg)',
      },
    },
    '& .MuiInput-underline:after': {
      display: 'none',
    },
    '& .MuiInput-underline:before': {
      display: 'none',
    },
  },
  legend: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    fontSize: 10,
    padding: '20px 0px 17px 0px',
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      marginRight: 16,
      '& div': {
        marginRight: 4,
        width: 8,
        height: 8,
        borderRadius: '50%',
      },
    },
  },
  composition: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 40,
  },
  label: {
    fontSize: 14,
    lineHeight: '18px',
    marginRight: 16,
  },
  filterYearContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  title: {
    fontSize: 20,
    lineHeight: '24px',
    fontWeight: 400,
    color: '#181818',
    marginRight: 5,
  },
  customToggleContainer: {
    paddingLeft: 0,
  },
  viewByTitle: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
    color: '#474747',
    marginRight: 16,
  },
  toggleBtnContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  compositionComplex: {
    paddingTop: 16,
  },
  toggleContainer: {
    paddingLeft: '50px !important',
    paddingRight: '0px !important',
    padding: '16px 0px 0px 0px !important',
    marginBottom: 0,
    marginTop: 10,
  },
  podToggle: {
    margin: 0,
  },
  driverToggle: {
    marginTop: 0,
    '& > div': {
      '& > div': {
        '@media (min-width:1600px)': {
          marginRight: '13px !important',
        },
      },
    },
  },
  toolTip: {
    color: '#8D9CB1',
    width: 16,
    height: 16,
    fontSize: 16,
    cursor: 'pointer',
    verticalAlign: 'middle',
    marginLeft: 5,
  },
  toolTipInModal: {
    color: '#8D9CB1',
    width: 20,
    height: 20,
    fontSize: 20,
    cursor: 'pointer',
    verticalAlign: 'middle',
    marginLeft: 10,
  },
  plusComparision: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    gap: 4,
    height: 18,
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '18px',
    letterSpacing: 0,
    color: '#1B3963',
    minWidth: 163,
    width: 'max-content',
    borderBottom: '1px solid transparent',
    paddingBottom: 2,
  },
  plusComparisionActive: {
    borderBottomColor: '#1B3963',
  },
  plusComparisionRight: {
    marginLeft: 'auto',
  },
  peerCompareRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    width: '100%',
    flexWrap: 'nowrap',
  },
  peerCompareControl: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flex: 1,
    minWidth: 0,
  },
  peerCompareControlCompact: {
    width: 'auto',
    flex: 1,
  },
  sbcHead: {
    height: 40,
    background: '#fff',
    borderRadius: 3,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    borderBottom: '1px solid #DFE4EB',
  },
  sbcHeadActive: {
    border: '1px solid #496182',
  },
  SearchIcon: {
    width: 36,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-end',
    paddingRight: 8,
  },
  inputSearch: {
    background: 'transparent',
    width: 'calc(100% - 36px)',
    height: '100%',
    border: 'none',
    outline: 'none',
    paddingRight: 32,
    boxSizing: 'border-box',
    '&::placeholder': {
      fontSize: 14,
      lineHeight: '22px',
      fontWeight: 400,
      color: '#757575',
    },
  },
  sbcContent: {
    background: 'white',
    padding: 0,
    boxSizing: 'border-box',
    position: 'absolute',
    top: 'calc(100% + 8px)',
    border: '1px solid #DFE4EB',
    boxShadow: '0px 2px 10px rgba(223, 228, 235, 0.5)',
    borderRadius: 3,
    zIndex: 2,
    left: 0,
    right: 0,
  },
  ClearIcon: {
    position: 'absolute',
    right: 12,
    top: 12,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    background: 'transparent',
  },
  sbcContentNoZero: {
    padding: 8,
  },
  sbcSearchContent: {
    marginTop: 0,
    maxHeight: 300,
    overflow: 'auto',
    padding: '8px 12px 12px',
    '&::-webkit-scrollbar': {
      width: 4,
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#DFE4EB',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: 'transparent',
    },
  },
  sbcTitleBlock: {
    fontSize: 12,
    lineHeight: '14px',
    fontWeight: 600,
    color: '#474747',
    marginBottom: 9,
  },
  SpinnerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      width: 20,
    },
  },
  RestoreIcon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  ClearSmallIcon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  sbcSearchItemHintLeft: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '& div:nth-child(2)': {
      marginLeft: 8,
      display: '-webkit-box',
      lineClamp: 2,
      boxOrient: 'vertical',
      width: '100%',
    },
  },
  sbcSearchItem: {
    boxSizing: 'border-box',
    padding: 4,
    color: '#474747',
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
    cursor: 'pointer',
    display: '-webkit-box',
    lineClamp: 2,
    boxOrient: 'vertical',
    '&:hover': {
      background: 'rgba(27, 57, 99, 0.1)',
      borderRadius: 3,
    },
  },
  sbcNoResult: {
    fontSize: 12,
    lineHeight: '14px',
    fontWeight: 400,
    color: '#8C8C8C',
  },
  ciqlCompare: {
    alignItems: 'center',
    background: '#EDF2F7',
    boxShadow: '0 0 8px 0 rgb(70 78 86 / 25%)',
    color: '#464e56',
    display: 'inline-flex!important',
    float: 'none',
    height: 30,
    justifyContent: 'space-between',
    marginRight: 8,
    maxWidth: '95%',
    padding: 0,
    position: 'relative',
    verticalAlign: 'bottom',
    opacity: 1,
    borderRadius: 2,
    borderLeftWidth: 3,
  },
  ciqlInfoCompare: {
    background: 'none',
    border: 'none',
    color: '#181818',
    fontWeight: 600,
    height: '100%',
    margin: 0,
    outline: 'none',
    padding: '0 6 px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: 14,
    lineHeight: '22px',
    cursor: 'pointer',
  },
  ciqlSymbol: {
    margin: '0px 8px',
  },
  ciqlDeleteCompare: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    height: '100%',
    outline: 'none',
    padding: '0',
    display: 'flex',
    alignItems: 'center',
  },
  ciqlColorCompare: {
    borderBottomLeftRadius: '3px',
    borderTopLeftRadius: '3px',
    height: '100%',
    width: '3px',
  },
  listCiqlCompare: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginRight: 0,
    marginLeft: 0,
    fontSize: '13px',
    flexWrap: 'nowrap',
    flex: '0 1 auto',
    overflowX: 'auto',
    overflowY: 'hidden',
    whiteSpace: 'nowrap',
    '&::-webkit-scrollbar': {
      height: 4,
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#DFE4EB',
    },
  },
  divPeerCompare: {
    margin: ' 0px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '100%',
    position: 'relative',
  },
  divPeerCompareDesktopSlot: {
    minHeight: 20,
  },
  divPeerCompareDesktopSlotWithItems: {
    minHeight: 30,
  },
})

const FundamentalsCreditAnalysis = ({ companyInfo, riskStatus }) => {
  const classes = useStyles()
  const {
    state,
    getCreditSeriesComparison,
    deleteItemComparisonState,
  } = useContext(PortfolioContext)
  const [viewBy, setViewBy] = React.useState(null)
  const [isOpenExpandModal, setOpenExpandModal] = React.useState(false)
  const [chartDetail, setChartDetail] = React.useState({})
  const [chartsData, setChartsData] = useState(charts)
  const [podToggleObj, setPodToggleObj] = useState({
    showCompanyHistory: true,
    showPeerGroup: false,
    showEquityPrice: false,
    podCompare1: false,
    podCompare2: false,
    podCompare3: false,
  })
  const [driverToggleObj, setDriverToggleObj] = useState({
    showAssetVolatility: false,
    showLeverage: false,
    showMarketValueOfAssets: true,
  })

  const [openTooltip, setOpenTooltip] = React.useState('')
  const [tooltipInfo, setTooltipInfo] = React.useState({})
  const [showContentSearch, setShowContentSearch] = useState(false)
  const compareWrapRef = useRef(null)
  const compareAnchorRef = useRef(null)
  const [compareLeft, setCompareLeft] = useState(0)
  const [dymamicSearchList, setDynamicSearchList] = useState([])
  const [breakStep, setBreakStep] = useState(1)
  const [isNotHaveData, setIsNotHaveData] = useState(false)
  const [inputValue, setInputValue] = useState('')
  const [dataCompare, setDataCompare] = useState([])

  const handleClickOpenTooltip = chart => {
    setOpenTooltip(chart.id)
    setTooltipInfo(chart.tooltipInfo)
  }
  const showImpliedRating = getCookie('implied_rating_flag') !== 'False'

  useEffect(() => {
    if (state?.creditData) {
      const chartCopied = chartsData
      chartCopied.pod.data = state.creditData?.pod ?? []
      chartCopied.driver.data = state.creditData?.driver ?? []
      chartCopied.impliedRating.data = state.creditData?.impliedRating ?? []
      setChartsData(chartCopied)
    }
  }, [state.creditData])

  useEffect(() => {
    const chartsCopy = _.cloneDeep(charts)
    const chartFilterData = filterChartProps(chartsCopy) // chartsCopy.map(i => filterChartProps(i))
    if (state?.creditData?.podCompare) {
      chartFilterData.pod.data = mergePodCompareToPod(
        chartFilterData.pod.data,
        state?.creditData?.podCompare,
      )
      getDataCompareFromContext(state?.creditData?.podCompare)
    }

    setChartsData(chartFilterData)
    if (chartDetail.id) {
      setChartDetail(chartFilterData[chartDetail.id])
    }
  }, [podToggleObj, driverToggleObj, isOpenExpandModal, state.creditData])

  const filterChartProps = charts => {
    const chartCopy = _.cloneDeep(charts)
    for (const chartId in chartCopy) {
      const chart = chartCopy[chartId]
      const { lineKeys } = chart

      chart.data.map(data => {
        if (chart.id === 'pod') {
          !podToggleObj.showCompanyHistory && delete data[`${lineKeys[0]}`]
          !podToggleObj.showPeerGroup && delete data[`${lineKeys[1]}`]
          !podToggleObj.showEquityPrice && delete data[`${lineKeys[2]}`]
          !podToggleObj.podCompare1 && delete data[`${lineKeys[3]}`]
          !podToggleObj.podCompare2 && delete data[`${lineKeys[4]}`]
          !podToggleObj.podCompare3 && delete data[`${lineKeys[5]}`]
        } else if (chart.id === 'driver') {
          !driverToggleObj.showAssetVolatility && delete data[`${lineKeys[0]}`]
          !driverToggleObj.showLeverage && delete data[`${lineKeys[1]}`]
          !driverToggleObj.showMarketValueOfAssets &&
            delete data[`${lineKeys[2]}`]
        }
      })
    }
    return chartCopy
  }

  const handeExpandChart = chart => {
    setChartDetail(chartsData[chart.id])
    setViewBy(chart.id)
    setOpenExpandModal(true)
  }

  const handleChangeViewBy = val => {
    // TODO: NEED fix change view_by
    setViewBy(val.value)
    const chartsCopy = _.cloneDeep(chartsData)
    const chartFilterData = filterChartProps(chartsCopy) // chartsCopy.map(i => filterChartProps(i))
    for (const c in chartFilterData) {
      chartFilterData[c].title === val.value &&
        setChartDetail(chartFilterData[c])
    }
  }

  const getDropdownListChart = charts => {
    const listChart = []
    charts.pod.data.length > 1 && listChart.push(charts.pod)
    charts.driver.data.length > 1 && listChart.push(charts.driver)
    return listChart
  }

  const handleScrollContent = evt => {
    if (
      evt.target.scrollHeight - evt.target.scrollTop >=
      evt.target.clientHeight
    ) {
      let timeout = null
      window.clearTimeout(timeout)
      timeout = setTimeout(() => {
        setBreakStep(prev => prev + 1)
      }, 200)
    }
  }

  const onHandleClearInput = () => {
    setInputValue('')
    getSearchResultByString('')
  }

  const onHandleChangeInput = event =>
    getSearchResultByString(event.target.value)

  const getSearchResultByString = str => {
    setInputValue(str)
    const cloned = JSON.parse(JSON.stringify(state?.tickersInUniverse))
    const filteredList = cloned.filter(
      item => item.searchTerm.toLowerCase().indexOf(str.toLowerCase()) !== -1,
    )
    if (filteredList?.length == 0) {
      setIsNotHaveData(true)
    } else {
      setIsNotHaveData(false)
    }
    setDynamicSearchList(filteredList)
  }

  const onHandleClickItem = data => {
    onHandleClearInput()
    setDynamicSearchList([])
    const fromDate = '2017-01-03'
    const toDate = '2030-01-01'
    const ticketId = data?.ticker
    if (!getCookie('userId')) {
      userService
        .getUser(getCookie('email'))
        .then(async res => {
          setCookieHelper('userId', res.data, EXPIRED_SECOND)
          const userId = res.data
          getCreditSeriesComparison(userId, ticketId, fromDate, toDate)
        })
        .catch(() => {})
    } else {
      const userId = getCookie('userId')
      getCreditSeriesComparison(userId, ticketId, fromDate, toDate)
    }
    setShowContentSearch(false)
    setPodToggleObj(prev => getPodToggleStateAfterCustomPeerAdded(prev))
  }

  // add list data compare to state off current file
  const getDataCompareFromContext = compareLists => {
    if (
      typeof compareLists == 'object' &&
      Object.keys(compareLists).length > 0
    ) {
      let dataNews = []
      for (const [key, value] of Object.entries(compareLists)) {
        if (key === 'pod_compare1' && value && value.length > 0) {
          dataNews.push({
            ...value[0],
            color: FUNDAMENTAL_TOGGLE_COLOR.POD_COMPARE1,
          })
        }
        if (key === 'pod_compare2' && value && value.length > 0) {
          dataNews.push({
            ...value[0],
            color: FUNDAMENTAL_TOGGLE_COLOR.POD_COMPARE2,
          })
        }
        if (key === 'pod_compare3' && value && value.length > 0) {
          dataNews.push({
            ...value[0],
            color: FUNDAMENTAL_TOGGLE_COLOR.POD_COMPARE3,
          })
        }
      }
      setDataCompare(dataNews)
    }
  }

  const clearItemPodCompare = itemClear => {
    deleteItemComparisonState(itemClear)
    const dataCompareNew = dataCompare.filter(it => {
      if (it && it?.ticker !== itemClear.ticker) {
        return true
      }
      return false
    })

    setDataCompare(dataCompareNew)
    if (dataCompareNew.length === 0) {
      setPodToggleObj(prev => ({
        ...prev,
        podCompare1: false,
        showPeerGroup: false,
      }))
    } else if (dataCompareNew.length === 1) {
      setPodToggleObj(prev => ({ ...prev, podCompare2: false }))
    } else if (dataCompareNew.length === 2) {
      setPodToggleObj(prev => ({ ...prev, podCompare3: false }))
    }
  }
  const checkShowingToogleOption = index => {
    let result
    switch (index) {
      case TOGGLE_INDEX.MARKET_VALUE_OF_ASSET:
        result = charts.driver.data.some(
          obj => obj.asset_market_value && obj.asset_market_value !== 'null',
        )
        break
      case TOGGLE_INDEX.ASSET_VOLATILITY:
        result = charts.driver.data.some(
          obj => obj.asset_volatility && obj.asset_volatility !== 'null',
        )
        break
      case TOGGLE_INDEX.LEVERAGE:
        result = charts.driver.data.some(
          obj => obj.leverage && obj.leverage !== 'null',
        )
        break
      case TOGGLE_INDEX.PEER_GROUP:
        result = charts.pod.data.some(
          obj => obj.peer_pod && obj.peer_pod !== 'null',
        )
        break
      default:
        result = true
        break
    }
    return result
  }

  const listSearchCompany = useMemo(() => {
    let listTickerIgnore = []
    listTickerIgnore.push(companyInfo?.ticker)
    if (dataCompare.length > 0) {
      dataCompare.forEach(ti => {
        listTickerIgnore.push(ti?.ticker)
      })
    }

    return dymamicSearchList.filter(
      it => !listTickerIgnore.includes(it?.ticker),
    )
  }, [dymamicSearchList, dataCompare])

  useEffect(() => {
    const updateCompareLeft = () => {
      if (!compareWrapRef.current || !compareAnchorRef.current) {
        return
      }
      const wrapRect = compareWrapRef.current.getBoundingClientRect()
      const anchorRect = compareAnchorRef.current.getBoundingClientRect()
      const nextLeft = Math.max(0, anchorRect.left - wrapRect.left)
      setCompareLeft(nextLeft)
    }
    updateCompareLeft()
    window.addEventListener('resize', updateCompareLeft)
    return () => {
      window.removeEventListener('resize', updateCompareLeft)
    }
  }, [showContentSearch, dataCompare])

  const buttonCompare = dataChart => {
    const hasCompare = dataCompare && dataCompare.length > 0
    return (
      <>
        {dataChart?.id === 'pod' && (
          <OutsideClickHandler
            onOutsideClick={() => {
              if (!isOpenExpandModal) {
                setShowContentSearch(false)
              }
              onHandleClearInput()
              setDynamicSearchList([])
            }}
          >
            <div className={classes.peerCompareRow} ref={compareWrapRef}>
              {hasCompare && (
                <div className={classes.listCiqlCompare}>
                  {dataCompare.map(co => (
                    <section
                      className={classes.ciqlCompare}
                      onClick={() => clearItemPodCompare(co)}
                      key={co?.ticker}
                    >
                      <span
                        className={classes.ciqlColorCompare}
                        style={{ backgroundColor: `${co?.color}` }}
                      ></span>
                      <button className={classes.ciqlInfoCompare}>
                        <span className={classes.ciqlSymbol}>{co?.ticker}</span>
                      </button>
                      <button className={classes.ciqlDeleteCompare}>
                        {' '}
                        <CloseIcon
                          viewBox={'0 0 35 24 '}
                          style={{ fontSize: '21px' }}
                        />
                      </button>
                    </section>
                  ))}
                </div>
              )}
              {dataCompare?.length < 3 && (
                <div
                  className={`${classes.peerCompareControl} ${
                    hasCompare ? classes.peerCompareControlCompact : ''
                  }`}
                  ref={compareAnchorRef}
                >
                  <div
                    className={`${classes.plusComparision} ${
                      showContentSearch ? classes.plusComparisionActive : ''
                    }`}
                    onClick={() => {
                      if (dataCompare.length < 3) {
                        setShowContentSearch(true)
                      }
                    }}
                  >
                    <ControlPointIcon
                      key={dataChart.id}
                      style={{ fontSize: '14px', color: '#1B3963' }}
                    />
                    <span>Custom Peer Comparison</span>
                  </div>
                </div>
              )}
            </div>
            {showContentSearch && dataCompare?.length < 3 && (
              <div className={classes.sbcContent} style={{ left: compareLeft }}>
                <div
                  className={`${classes.sbcHead} ${
                    inputValue !== '' ? classes.sbcHeadActive : ''
                  }`}
                >
                  <div className={classes.SearchIcon}>
                    <SearchIcon />
                  </div>
                  {inputValue.length !== 0 && (
                    <div
                      onClick={onHandleClearInput}
                      className={classes.ClearIcon}
                    >
                      <ClearIcon />
                    </div>
                  )}
                  <input
                    type="text"
                    value={inputValue}
                    onChange={onHandleChangeInput}
                    placeholder={'Search for company'}
                    className={classes.inputSearch}
                  />
                </div>
                <div
                  onScroll={handleScrollContent}
                  className={classes.sbcSearchContent}
                >
                  {listSearchCompany.length !== 0 && (
                    <div>
                      {listSearchCompany
                        .slice(0, 20 + 15 * (breakStep - 1))
                        .map((item, index) => (
                          <div
                            onClick={() => onHandleClickItem(item)}
                            key={index}
                            className={classes.sbcSearchItem}
                          >
                            {item.proper_name}
                          </div>
                        ))}
                    </div>
                  )}

                  {5 * breakStep < listSearchCompany?.length && (
                    <div className={classes.SpinnerContainer}>
                      <img alt="spinner" src={Spinner} />
                    </div>
                  )}

                  {isNotHaveData && (
                    <div className={classes.sbcNoResult}>
                      No result found. Please try different keyword.
                    </div>
                  )}
                </div>
              </div>
            )}
          </OutsideClickHandler>
        )}
      </>
    )
  }

  const chartDiv = useMemo(
    () => (chart, inModal, podToggleObj, driverToggleObj, isFirst) => {
      const lineKeys = chart?.lineKeys
      return (
        <Grid
          key={chart.id}
          id={chart.id}
          item
          xs={12}
          sm={12}
          className={`${classes.chartDiv} ${
            isFirst ? classes.chartDivFirst : ''
          }`}
        >
          {/* selection !== null && chart.id !== undefined && selection.id === chart.id && <Snackbar message={message} id={selection.id}/> */}
          {chart.id !== 'impliedRating' && (
            <>
              <div className={classes.chartHeader}>
                <div
                  className={
                    inModal ? classes.subheadingInModal : classes.subheading
                  }
                >
                  {chart.title}
                  <HelpRounded
                    className={
                      inModal ? classes.toolTipInModal : classes.toolTip
                    }
                    key={chart.id}
                    onClick={() => handleClickOpenTooltip(chart)}
                  />
                  {chart?.subTitle && (
                    <span className={classes.subTitle}>({chart.subTitle})</span>
                  )}
                </div>
                <div className={classes.help}>
                  {inModal && (
                    <div>
                      <Typography className={classes.label}>View by</Typography>
                      <FilterBoxCommon
                        placeholder="Credit Stress Measure"
                        data={getDropdownListChart(chartsData).map(item => {
                          return {
                            ...item,
                            value: item.title,
                          }
                        })}
                        selectedValue={chart.title}
                        setFilterValue={val => handleChangeViewBy(val)}
                        isSearch={false}
                        isRadio
                        customStyle={{ width: 260 }}
                        customStyleBody={{ width: 320 }}
                        outSelectedItems={[]}
                      />
                      <input
                        className={classes.closeBtn}
                        type="image"
                        onClick={() => setOpenExpandModal(false)}
                        src={closePopupIcon}
                        alt="closeBtn"
                      />
                    </div>
                  )}
                  {!inModal && !isOpenExpandModal && !isSafari && (
                    <img
                      src={expandIcon}
                      onClick={() => handeExpandChart(chart)}
                      className={`${classes.expandIcon} tooltip`}
                      // the id indicates that this element is ignored when pdf is generated
                      id={`expandChartBtn-chart-${chart.id}`}
                    />
                  )}
                </div>
              </div>
            </>
          )}
          <div
            className={`${classes.divPeerCompare} ${
              !inModal ? classes.divPeerCompareDesktopSlot : ''
            } ${
              !inModal && dataCompare.length > 0
                ? classes.divPeerCompareDesktopSlotWithItems
                : ''
            }`}
          >
            <div className={classes.subheading}>{buttonCompare(chart)}</div>
          </div>
          {chart.id === 'pod' && (
            <>
              <div
                className={!inModal ? classes.podToggle : ''}
                onClick={() => {
                  if (inModal) {
                    setShowContentSearch(false)
                  }
                }}
              >
                <ChartD3ToggleGroup
                  setToggleObj={val => setPodToggleObj(val)}
                  toggleObj={podToggleObj}
                  inModal={inModal}
                  showPeerGroup={checkShowingToogleOption(
                    TOGGLE_INDEX.PEER_GROUP,
                  )}
                  showCompany
                  showEquityPrice
                  companyColor={FUNDAMENTAL_TOGGLE_COLOR.COMPANY_HISTORY_FC}
                  peerGroupColor={FUNDAMENTAL_TOGGLE_COLOR.PEER_GROUP_FC}
                  chartId={chart.id}
                />
              </div>
              <div
                className={
                  !inModal ? classes.smallLineChart : classes.fullLineChart
                }
                onClick={() => {
                  if (inModal) {
                    setShowContentSearch(false)
                  }
                }}
              >
                <PoDChart
                  key={chart.id}
                  lineKeys={lineKeys}
                  inModal={inModal}
                  chartId={chart.id}
                  data={chart.data}
                  relations={chart}
                  setSelection={() => {}}
                />
              </div>
            </>
          )}
          {chart.id === 'driver' && (
            <>
              <div className={!inModal ? classes.driverToggle : ''}>
                <ChartD3ToggleGroup
                  setToggleObj={val => setDriverToggleObj(val)}
                  toggleObj={driverToggleObj}
                  inModal={inModal}
                  showMarketValueOfAssets={checkShowingToogleOption(
                    TOGGLE_INDEX.MARKET_VALUE_OF_ASSET,
                  )}
                  showAssetVolatility={checkShowingToogleOption(
                    TOGGLE_INDEX.ASSET_VOLATILITY,
                  )}
                  showLeverage={checkShowingToogleOption(TOGGLE_INDEX.LEVERAGE)}
                  chartId={chart.id}
                />
              </div>
              <div
                className={
                  !inModal ? classes.smallLineChart : classes.fullLineChart
                }
              >
                <DriverChart
                  key={chart.id}
                  lineKeys={lineKeys}
                  inModal={inModal}
                  chartId={chart.id}
                  data={chart.data}
                  relations={chart}
                  setSelection={() => {}}
                />
              </div>
            </>
          )}
          {chart.id === 'impliedRating' && (
            <div className={classes.impliedRatingChartDiv}>
              <ImpliedRatingChart
                left={60}
                right={40}
                data={chart.data}
                inModal={inModal}
                chartId={chart.id}
              />
            </div>
          )}
        </Grid>
      )
    },
    [chartsData, showContentSearch, inputValue, dataCompare],
  )

  return (
    <PageSection
      title="Fundamentals - Credit Analysis"
      subTitle="Fair value-based credit assessment"
      fundamentalCreditTooltip
      companyInfo={companyInfo}
      showImpliedRating={showImpliedRating}
      isShowingRisk={false}
      riskStatus={riskStatus}
    >
      <></>
      <>
        <Grid className={classes.marketContextContainer} container spacing={3}>
          <Grid container>
            {chartsData.pod.data.length > 1 && (
              <Grid item xs={6} sm={6}>
                {chartDiv(
                  chartsData.pod,
                  false,
                  podToggleObj,
                  driverToggleObj,
                  true,
                )}
              </Grid>
            )}
            {chartsData.driver.data.length > 1 && (
              <Grid item xs={6} sm={6}>
                {chartDiv(
                  chartsData.driver,
                  false,
                  podToggleObj,
                  driverToggleObj,
                )}
              </Grid>
            )}
            {chartsData.impliedRating.data.length > 1 && (
              <Grid item xs={12} sm={12}>
                {chartDiv(chartsData.impliedRating, false)}
              </Grid>
            )}
          </Grid>
        </Grid>
        <PoDTooltipModal
          open={openTooltip === 'pod'}
          handleClose={() => {
            setOpenTooltip('')
          }}
          tooltipInfo={tooltipInfo}
        />
        <DriverTooltipModal
          open={openTooltip === 'driver'}
          handleClose={() => {
            setOpenTooltip('')
          }}
          tooltipInfo={tooltipInfo}
        />
        <ChartDialog
          chart={chartDiv(chartDetail, true, podToggleObj, driverToggleObj)}
          isOpenExpandModal={isOpenExpandModal}
          setOpenExpandModal={value => {
            d3.selectAll(`.line-chart${chartDetail.id}-inModal`).remove()
            d3.selectAll(`.stackarea-chart${chartDetail.id}-inModal`).remove()
            setOpenExpandModal(value)
            setShowContentSearch(false)
          }}
        />
      </>
    </PageSection>
  )
}

export default FundamentalsCreditAnalysis
